@use '@design/design-tokens/typography/typography' as *;

.earningsWidgetRoot {
  width: 100%;
  margin-top: 14px;
  @include typography-v2-body-base;
}
